import script from "./UCDate.vue?vue&type=script&setup=true&lang=js"
export * from "./UCDate.vue?vue&type=script&setup=true&lang=js"

import "./UCDate.vue?vue&type=style&index=0&id=4ee4c69c&lang=css"

const __exports__ = script;

export default __exports__